export const routes = {
  root: "/",

  assignment: {
    list: "/assignments/",
    view: "/assignments/:uuid/",
    student: "/assignments/student/:id/",
  },

  submission: {
    view: "/submissions/:id/",
  },

  students: {
    list: "/students/",
    view: "/students/:id/",
  },

  classes: {
    home: "/classes/",
    class: "/classes/class/:id/",
  },

  documents: "/documents/",

  eqa: {
    list: "/eqa/",
    learner: "/eqa/:studentId/",
    module: "/eqa/:studentId/:moduleShortName/",
  },

  pageNotFound: "/*",
} as const
